/** Only the approved public homepage watch section opts in; catalogue and brand routes stay separate. */
export function signatureHomepageEnabled(doc: Document = document, location: Pick<Location, 'hostname' | 'pathname'> = window.location): boolean {
  return ['www.raffi-jewellers.ca', 'raffi-jewellers.ca'].includes(location.hostname)
    && /^\/(?:fr\/?)?$/.test(location.pathname)
    && !!doc.querySelector('section#home-watch-discovery[data-signature-home][data-watch-buying="home"]');
}
